module.exports = __webpack_public_path__ + "img/arrow_up.0aae1e58.svg";